var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c(
        "div",
        {
          ref: "carouselContainer",
          staticClass: "list-item-carousel owl-carousel owl-theme",
        },
        _vm._l(_vm.$slots.items, function (item, index) {
          return _c("slot-component", { key: index, attrs: { vnode: item } })
        }),
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }